module.exports = __webpack_public_path__ + "static/media/9DESA26.1cbc661c.jpg";